"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _common = require("@nestjs/common");
const _globals = require("~/utils/globals");
const logger = new _common.Logger('nc_046_comment_mentions');
const READ_BATCH_SIZE = 1000;
const INSERT_BATCH_SIZE = 200;
const up = async (knex)=>{
    logger.log('Migration Started');
    let fetchNextBatch = true;
    const insertedIds = new Set();
    for(let offset = 0; fetchNextBatch; offset += READ_BATCH_SIZE){
        const rows = await knex.select(`${_globals.MetaTable.AUDIT}.id`, `${_globals.MetaTable.AUDIT}.row_id`, `${_globals.MetaTable.AUDIT}.description`, `${_globals.MetaTable.AUDIT}.user as user_email`, `${_globals.MetaTable.AUDIT}.source_id`, `${_globals.MetaTable.AUDIT}.base_id`, `${_globals.MetaTable.AUDIT}.fk_model_id`, `${_globals.MetaTable.AUDIT}.created_at`, `${_globals.MetaTable.AUDIT}.updated_at`, `${_globals.MetaTable.USERS}.id as user_id`).from(_globals.MetaTable.AUDIT).where(`${_globals.MetaTable.AUDIT}.op_type`, 'COMMENT').leftJoin(_globals.MetaTable.USERS, `${_globals.MetaTable.AUDIT}.user`, `${_globals.MetaTable.USERS}.email`).orderBy(`${_globals.MetaTable.AUDIT}.id`).offset(offset)// increase limit by 1 to check if there are more rows
        .limit(READ_BATCH_SIZE + 1);
        logger.log(`Data from Audit Table fetched, batch: ${offset} - ${offset + READ_BATCH_SIZE}`);
        const formattedRows = rows// exclude the last row since it was used to check if there are more rows
        .slice(0, READ_BATCH_SIZE).filter((row)=>{
            if (insertedIds.has(row.id)) {
                return false;
            }
            insertedIds.add(row.id);
            return true;
        }).map((row)=>{
            var _row_description, _row_description1;
            return {
                id: row.id,
                row_id: row.row_id,
                comment: ((_row_description = row.description) != null ? _row_description : '').substring(((_row_description1 = row.description) != null ? _row_description1 : '').indexOf(':') + 1).trim(),
                created_by: row.user_id,
                created_by_email: row.user_email,
                source_id: row.source_id,
                base_id: row.base_id,
                fk_model_id: row.fk_model_id,
                created_at: row.created_at,
                updated_at: row.updated_at
            };
        });
        logger.log('Data from Audit Table formatted');
        await knex.batchInsert(_globals.MetaTable.COMMENTS, formattedRows, INSERT_BATCH_SIZE);
        // check if there are more rows to fetch
        fetchNextBatch = rows.length > READ_BATCH_SIZE;
    }
    logger.log('Data migrated from Audit Table to Comments Table');
};
const down = async (knex)=>{
    await knex.schema.dropTable(_globals.MetaTable.COMMENTS);
};
